// Freight is always the last section — in the builder, on the web view and in
// the PDF, below the common items as well. Craig, 2026-09-20: "no matter what
// is added to the quote, the freight is always the bottom section in the quote
// build and in the web and pdf. So it is below the common items as well,
// always."
//
// ⛔ TWO COPIES OF THIS RULE, DELIBERATELY. The document is rendered by the
// backend's quoteRenderer.js (a Node service that cannot import this module),
// which carries a PORT of both functions under the same names and a comment
// pointing back here; tests/quoteRenderer.test.js over there pins the port
// against a verbatim reference — the same arrangement as quantityOf. Change
// the rule here and change it there in the same commit, or the builder and the
// document order sections differently, which is exactly the class of drift the
// preview/PDF byte-identity test exists to prevent.
//
// The rule is applied at RENDER time in both places, never by mutating the
// stored order: a section appended after freight exists (by + Section, a
// template or the AI) still renders above it, and a quote whose stored order
// has freight first is not "wrong", merely displayed correctly.

/** The generated freight section, identified by the flag the generator sets —
 *  never by its label. A section a person named "Freight & Delivery" by hand
 *  is an ordinary section. */
export const isFreightSection = (s) => !!(s && s.autoCalculated);

/** Display order: every non-freight section in stored order, then every
 *  freight section in stored order. A STABLE partition — a quote that somehow
 *  carries two freight sections keeps their relative order. */
export function orderSections(sections) {
  const list = Array.isArray(sections) ? sections : [];
  return [...list.filter((s) => !isFreightSection(s)), ...list.filter(isFreightSection)];
}
